import React from 'react';
import Logo from '../Header/logo-fcsaude.png'
import { FaWhatsapp, FaComments, FaPhoneAlt } from 'react-icons/fa'
import LogoHubcare from './logo-hubcare-gestao-saude.png'

function Footer() {
    return (
        <div className="Footer">
            <div className="container">

                <div className="row">
                    <div className="col-md-6">
                        <img src={Logo} alt="FC Saúde" height="40" />
                        <p>
                            Copyright © 2023 - FutebolCard Saúde - CNPJ 01.329.666/0001-50.<br />
                            Todos os direitos reservados.
                        </p>
                    </div>
                    <div className="col-md-3">
                        <h3>Atendimento</h3>
                        <ul>
                            <li><a href="https://figueirasaude.com.br/#"><span><FaComments /></span> contato@futebolcard.com.br</a></li>
                            <li><a href="https://futebolcard.neoassist.com/?th=chatNeoa"><span><FaWhatsapp /></span>Chat</a></li>
                        </ul>
                    </div>
                    <div className="col-md-3 text-center text-md-end">
                        <img src={LogoHubcare} alt="Hub Care" />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer;